import { type EditorState, PluginKey } from '@tiptap/pm/state';
import type { EditorView } from '@tiptap/pm/view';

// Reuse the same plugin key to manter compatibilidade
export const pluginKey = new PluginKey<OpenAskAiState>('openAskAi');

export type OpenAskAiState = {
  open: boolean;
  nodePos?: number;
};

export const getOpenAskAiState = (state: EditorState): OpenAskAiState => {
  return pluginKey.getState(state) || { open: false, nodePos: undefined };
};

export const setOpenAskAi = (view: EditorView, askAi: OpenAskAiState) => {
  view.dispatch(view.state.tr.setMeta(pluginKey, askAi));
};
